import React from "react";

const Contact = () => {
  return (
    <div>
      <a href="http://vmrda.gov.in/contactus.aspx" target="_blank" />
    </div>
  );
};

export default Contact;
